export default function ($) {

    const MINIMUM = 35;

    if (!$('#yith-ywraq-form, .wpcf7-form').length || !$('td.product-quantity input.qty').length) return;

    function totalQuantity() {
        return $('td.product-quantity input.qty').toArray().reduce((total, input) => total + (parseInt(input.value, 10) || 0), 0);
    }

    function guard(e) {
        if (totalQuantity() >= MINIMUM) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        alert(`Het totaal aantal producten moet minimaal ${MINIMUM} stuks zijn.`);
    }

    $(document).on('click', '.wpcf7-form [type="submit"]', guard);
    $(document).on('submit', '#yith-ywraq-form', guard);

}
